import axios from 'commons/baseUrl'
import {
  CLEAR_DELIVERY_DATA_DETAIL,
  GET_DELIVERY_DATA_DETAIL_LIST_FAILED,
  GET_DELIVERY_DATA_DETAIL_LIST_REQUEST,
  GET_DELIVERY_DATA_DETAIL_LIST_SUCCESS,
} from 'constants/actionTypes/deliveryDataDetailActionTypes'
import { API_GET_DELIVERY_DATA_DETAIL } from 'constants/apiPath'
import { RESPONSE_TYPE } from 'constants/constant'

const getDeliveryDataDetailAction = (params) => async (dispatch) => {
  try {
    dispatch({ type: GET_DELIVERY_DATA_DETAIL_LIST_REQUEST })
    const res = await axios.get(API_GET_DELIVERY_DATA_DETAIL, { params })
    if (!res.data || res.data.STS === RESPONSE_TYPE.ERROR) {
      dispatch({ type: GET_DELIVERY_DATA_DETAIL_LIST_FAILED, payload: res.data.message })
      throw new Error()
    }
    if (res.data.STS === RESPONSE_TYPE.SUCCESS && res.data.data) {
      dispatch({ type: GET_DELIVERY_DATA_DETAIL_LIST_SUCCESS, payload: res.data.data })
    }
  } catch (err) {
    dispatch({ type: GET_DELIVERY_DATA_DETAIL_LIST_FAILED, payload: err.message })
  }
}

const clearDeliveryDataDetail = (data) => async (dispatch) => {
  dispatch({ type: CLEAR_DELIVERY_DATA_DETAIL, payload: '' })
}

export { clearDeliveryDataDetail, getDeliveryDataDetailAction }
